import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map, Observable } from 'rxjs';
import { PREFERENCE_CODES } from '../graphql/preference-code.query';

@Injectable({
  providedIn: 'root'
})
export class PreferenceCodeService {

  constructor(private apollo: Apollo) { }
  fetchPreferenceCodes(search: any,type:any): Observable<any> {
      return this.apollo
        .use('project')
        .query<any>({
          query: PREFERENCE_CODES,
          variables: {
            search,type
          },
          fetchPolicy: 'network-only',
        })
        .pipe(map((result) => result.data?.preferenceCodes || []));
    }
}
